function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLinkedin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.349,
    height: 45.349,
    viewBox: "0 0 45.349 45.349",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ha8n61giha"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 87",
    style: {
      fill: "#666"
    },
    d: "M0 0h45.349v45.349H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1958"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 137",
    style: {
      clipPath: "url(#ha8n61giha)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 77",
    d: "M22.675 45.349A22.675 22.675 0 0 1 0 22.675a22.675 22.675 0 0 1 45.349 0 22.674 22.674 0 0 1-22.674 22.674",
    transform: "translate(0 -.017)",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 86",
    transform: "translate(15.347 20.062)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.17v10.107H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 78",
    d: "M84.252 75.34q-.179-.02-.367-.028a3.7 3.7 0 0 0-3.124 1.43 2.245 2.245 0 0 0-.138.2v-1.354h-3.032v10.106h3.17v-4.748a4.127 4.127 0 0 1 .29-2.042 1.547 1.547 0 0 1 1.41-.79 1.681 1.681 0 0 1 1.792 1.734v5.892h3.17v-6.592c0-2.256-1.147-3.59-3.17-3.808",
    transform: "translate(-57.167 -55.503)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 79",
    d: "M61.021 59.184a1.838 1.838 0 1 1-1.838-1.838 1.838 1.838 0 0 1 1.838 1.838",
    transform: "translate(-42.251 -42.268)",
    style: {
      fill: "#fff"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-linkedin.6779ed311a6defce72efef838ec516d3.svg";